export const validateTreeDigitCode = (element) => {
  const valid = {
    isValid: true,
    message: "",
  };
  let result = /^\d{3}$/.test(element);
  if (!result) {
    valid.isValid = false;
    valid.message = "Must be exactly 3 digits";
  }

  return valid;
};



// WEBPACK FOOTER //
// ./src/components/CreateSite/Step2/Validation/TreeDigitCodeValidation.js